import { AgentStatus } from '@bandido/shared/constants';
import { Theme } from '@mui/material/styles';

export const getAgentStatusColor = (status: AgentStatus, theme: Theme) => {
  switch (status) {
    case AgentStatus.AVAILABLE:
      return theme.palette.success.main;
    case AgentStatus.NOT_AVAILABLE:
      return theme.palette.error.main;
    case AgentStatus.AFTER_CALL:
      return theme.palette.warning.main;
    case AgentStatus.BREAK:
      return theme.palette.warning.main;
    case AgentStatus.LUNCH:
      return theme.palette.info.main;
    case AgentStatus.NOT_APPLICABLE:
      return theme.palette.disabled.main;
    case AgentStatus.IN_CALL:
      return theme.palette.secondary.main;
    case AgentStatus.WORKING_IN_CASE:
      return theme.palette.secondary.main;
    default:
      return theme.palette.disabled.main;
  }
};
